import './App.css';
import CurrencyConverter from './CurrencyConverter'
function App() {
  return (
    <>
    <CurrencyConverter/>
    </>
  );
}

export default App;
